import { API } from "@/main.js";

const getDefaultState = () => {
    return {
        tabs:[],
        height:0,
        width:0,
    };
};

const state = getDefaultState();

const getters = {
    getMultiselectTabs: state => state.tabs,
    getMultiselectTabHeight: state => state.height,
    getMultiselectTabWidth: state => state.width,

};

const mutations = {
    SET_TABS(state, data) {
        state.tabs = data;
    },
    SET_TABS_HEIGHT(state, data) {
        state.tabs = data;
    },
    SET_TABS_WIDTH(state, data) {
        state.tabs = data;
    },
};

const actions = {
    SET_TABS_ACTION({ commit } , tabs) {
        commit("SET_TABS", tabs);
    },
    SET_TABS_HEIGHT_ACTION({ commit } , height) {
        commit("SET_TABS_HEIGHT", height);
    },
    SET_TABS_WIDTH_ACTION({ commit } , width) {
        commit("SET_TABS_WIDTH", width);
    },
};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/Home/multiselect.js